export function patchHTML(element, html) {
  if (!(element instanceof Element)) {
    return false;
  }
  if (element.innerHTML === html) {
    return false;
  }
  element.innerHTML = html;
  return true;
}

export function ensureShell(root, sentinelSelector, html) {
  if (!(root instanceof Element)) {
    return false;
  }
  if (root.querySelector(sentinelSelector)) {
    return false;
  }
  root.innerHTML = html;
  return true;
}

export function ensureModeLayout(element, attributeName, mode, html) {
  if (!(element instanceof Element)) {
    return false;
  }
  if (element.getAttribute(attributeName) === mode) {
    return false;
  }
  element.setAttribute(attributeName, mode);
  element.innerHTML = html;
  return true;
}

export function setStatus(state, message, tone = "idle") {
  if (!state || typeof state !== "object") {
    return { message: String(message || ""), tone: String(tone || "idle") };
  }
  state.status = {
    message: String(message || ""),
    tone: String(tone || "idle")
  };
  return state.status;
}
